"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _actions = require("../actions");

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.Map();
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _actions.SET_CAPI_CONFIG:
      {
        var url = action.url,
            token = action.token;
        return state.merge(new _immutable.Map({
          url: url,
          token: token
        }));
      }

    case _actions.SET_CAPI_SESSION:
      {
        var id = action.id;
        return state.set('sessionID', id);
      }

    case _actions.CLEAR_CAPI_SESSION:
      return state.delete('sessionID');

    default:
  }

  return state;
};

var _default = reducer;
exports.default = _default;